import { render, staticRenderFns } from "./PurchasesPieSecondHand.vue?vue&type=template&id=f8b09afc&scoped=true"
import script from "./PurchasesPieSecondHand.vue?vue&type=script&lang=js"
export * from "./PurchasesPieSecondHand.vue?vue&type=script&lang=js"
import style0 from "./PurchasesPieSecondHand.vue?vue&type=style&index=0&id=f8b09afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b09afc",
  null
  
)

export default component.exports